import React from "react";
import PropTypes from "prop-types";
import CommentList from "./CommentList";
import CommentAdd from "./CommentAdd";

const CommentContainer = ({ ticketId }) => {
  return (
    <div className="commentContainer">
      <fieldset role="presentation">
        <legend>Kommentarer</legend>
        <CommentList ticketId={ticketId} />
        <CommentAdd ticketId={ticketId} />
      </fieldset>
    </div>
  );
};

CommentContainer.propTypes = {
  ticketId: PropTypes.string.isRequired,
};

export default CommentContainer;
